import script from "./PostMarkdownLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PostMarkdownLoader.vue?vue&type=script&setup=true&lang=js"

import "./PostMarkdownLoader.vue?vue&type=style&index=0&id=450a0ff2&lang=css"

const __exports__ = script;

export default __exports__